var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('nav',{staticClass:"hiq-menu__wrapper",attrs:{"aria-label":"Meny"}},[_vm._m(0),_c('MenuContainer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"hiq-menu__toggler",attrs:{"id":"menuBtn","data-toggle":"#menuContainer","data-close-outside":""}},[_c('span',{staticClass:"show-for-sr"},[_vm._v("Öppna")]),_c('span',[_vm._v("Meny")])])
}]

export { render, staticRenderFns }